import React from "react";
import { Unsubscribe } from "../../components/Unsubscribe/Unsubscribe";
import { LoginLayout } from "../../layouts/LoginLayout/LoginLayout";

export function PageUnsubscribe() {
  return (
    <LoginLayout classNameMain="classNameMainRegCenter">
      <Unsubscribe />
    </LoginLayout>
  );
}
